<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_visits']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Advanced Filters Section -->
            <div class="row mb-3">
              <div class="col-md-2">
                <label class="form-label">Gender</label>
                <select v-model="filters.gender" class="form-select">
                  <option value="">All</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Age Range</label>
                <div class="d-flex gap-2">
                  <input type="number" v-model="filters.ageMin" class="form-control" placeholder="Min age">
                  <span class="align-self-center">-</span>
                  <input type="number" v-model="filters.ageMax" class="form-control" placeholder="Max age">
                </div>
              </div>
              <div class="col-md-2">
                <label class="form-label">Address</label>
                <input class="form-control" list="patientaddress" v-model="filters.address" placeholder="Enter Address..."/>
                <datalist id="patientaddress">
                  <option v-for="(addr, idx) in uniqueAddresses" :key="idx">{{ addr }}</option>
                </datalist>
              </div>
              <div class="col-md-5">
                <label class="form-label">Date Range (Added On)</label>
                <div class="d-flex gap-2">
                <input type="date" v-model="filters.dateFrom" class="form-control mb-1" placeholder="From">
                <input type="date" v-model="filters.dateTo" class="form-control" placeholder="To">
                </div>
              </div>
              </div>
              <div class="row mb-3">
              <div class="col-md-6 d-flex align-items-end">
                <button class="btn btn-secondary me-2" @click="clearFilters">
                  <i class="mdi mdi-filter-remove"></i> Clear Filters
                </button>
                <button class="btn btn-info" @click="applyFilters">
                  <i class="mdi mdi-filter"></i> Apply Filters
                </button>
              </div>
              <div class="col-md-6 d-flex align-items-end justify-content-end gap-2">
                <button class="btn btn-success" @click="exportToExcel">
                  <i class="mdi mdi-file-excel"></i> Export Excel
                </button>
                <button class="btn btn-danger" @click="printPatients">
                  <i class="mdi mdi-printer"></i> Print / PDF
                </button>
              </div>
            </div>

            <hr />

            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            
            <div class="table-responsive">
              <b-table
                :items="filteredItems"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
                striped
                hover
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>Loading...</strong></div></template>
              <template #cell(index)="data">
                {{ (currentPage - 1) * perPage + data.index + 1 }}
              </template>
              <template #cell(age)="data">
                {{ calculateAge(data.item.date_of_birth) }} <span class="text-primary">yrs</span>
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(addedon)="data">
                {{ formatDate(data.item.addedon) }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <router-link :to="{ path: '/profile',  query: { id: data.item.patient_id }}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-eye"></i></router-link>
                <b-button @click="edit(data.item.id,data.item.name,data.item.gender,data.item.telephone,data.item.nationality,data.item.address,data.item.date_of_birth )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit-patient> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete-patient> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="filteredListLength" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Patients</span></center>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <b-modal id="edit-patient" centered title="Edit Patient" title-class="font-14" hide-footer>
        <form @submit.prevent="editPatient">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient Name</label>
            <input v-model="name" type="text" class="form-control" required />
            <label>Gender</label>
              <select class="form-control" v-model="gender" required>
                <option>Female</option>
                <option>Male</option>
              </select>
            <label>Telephone</label>
            <input v-model="telephone" type="tel" class="form-control" required />
            <label>Date Of Birth</label>
            <input v-model="dateofbirth" type="date" class="form-control" required />
            <label>Nationality</label>
            <input v-model="nationality" type="text" class="form-control" required />
            <label>Address</label>
            <input v-model="address" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-patient')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <!-- Delete Modal -->
    <b-modal id="delete-patient" centered title="Delete Patient" title-class="font-18" hide-footer>
        <form @submit.prevent="removePatient">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Patient : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-patient')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

    <!-- Hidden print template -->
    <div id="print-template" style="display: none;">
      <div class="print-content">
        <div class="print-header">
          <h1>Patients List Report</h1>
          <p>Generated on: <span id="print-date"></span></p>
        </div>
        <div class="print-summary" id="print-summary"></div>
        <table class="print-table" id="print-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Gender</th>
              <th>Age</th>
              <th>Telephone</th>
              <th>Nationality</th>
              <th>Address</th>
              <th>Added By</th>
              <th>Added On</th>
            </tr>
          </thead>
          <tbody id="print-table-body">
          </tbody>
        </table>
        <div class="print-footer">
          <p>This report was generated automatically from the Patient Management System.</p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { patientMethods, patientComputed } from "@/state/helpers";
import * as XLSX from 'xlsx';

export default {
  page: {
    title: "View Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "View Patients", active: true }],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: ['name', 'telephone', 'nationality', 'address'],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true, sortable: true },
          { key: 'name', label: 'Name', visible: true, sortable: true },
          { key: 'gender', label: 'Gender', visible: true, sortable: true },
          { key: 'age', label: 'Age', visible: true, sortable: true },
          { key: 'telephone', label: 'Telephone', visible: true, sortable: true },
          { key: 'nationality', label: 'Nationality', visible: true, sortable: true },
          { key: 'address', label: 'Address', visible: true, sortable: true },
          { key: 'addedby', label: 'Added by', visible: true, sortable: true },
          { key: 'addedon', label: 'Added on', visible: true, sortable: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id: '',
      telephone: '',
      name: '',
      nationality: '',
      gender: '',
      address: '',
      dateofbirth: '',
      
      // Advanced filters
      filters: {
        gender: '',
        nationality: '',
        ageMin: '',
        ageMax: '',
        addedby: '',
        address: '',
        dateFrom: '',
        dateTo: ''
      },
      appliedFilters: {}
    };
  },
  computed: {
    ...patientComputed,
    List() { return this.patients.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.patients.map((d) => ({...d }))},
    IsBusy() { return this.patients.length === 0 },
    
    // Unique addresses for datalist
    uniqueAddresses() {
      return [...new Set(this.patients.map(item => item.address).filter(addr => addr))];
    },
    
    // Apply all filters
    filteredItems() {
      let items = [...this.patients];
      
      // Gender filter
      if (this.appliedFilters.gender) {
        items = items.filter(item => item.gender === this.appliedFilters.gender);
      }
      
      // Nationality filter
      if (this.appliedFilters.nationality) {
        items = items.filter(item => 
          item.nationality?.toLowerCase().includes(this.appliedFilters.nationality.toLowerCase())
        );
      }
      
      // Age range filter
      if (this.appliedFilters.ageMin) {
        items = items.filter(item => this.calculateAge(item.date_of_birth) >= parseInt(this.appliedFilters.ageMin));
      }
      if (this.appliedFilters.ageMax) {
        items = items.filter(item => this.calculateAge(item.date_of_birth) <= parseInt(this.appliedFilters.ageMax));
      }
      
      // Added by filter
      if (this.appliedFilters.addedby) {
        items = items.filter(item => 
          item.addedby?.toLowerCase().includes(this.appliedFilters.addedby.toLowerCase())
        );
      }
      
      // Address filter
      if (this.appliedFilters.address) {
        items = items.filter(item => 
          item.address?.toLowerCase().includes(this.appliedFilters.address.toLowerCase())
        );
      }
      
      // Date range filter
      if (this.appliedFilters.dateFrom) {
        items = items.filter(item => item.addedon >= this.appliedFilters.dateFrom);
      }
      if (this.appliedFilters.dateTo) {
        items = items.filter(item => item.addedon <= this.appliedFilters.dateTo);
      }
      
      return items;
    },
    
    filteredListLength() {
      return this.filteredItems.length;
    }
  },
  mounted() {
    this.fetchPatients();
    this.TotalRows = this.patients.length;
    this.isBusy = false;
  },
  methods: {
    ...patientMethods,
    
    calculateAge(dateOfBirth) {
      if (!dateOfBirth) return 'N/A';
      const birthDate = new Date(dateOfBirth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    
    formatDate(date) {
      if (!date) return 'N/A';
      return new Date(date).toLocaleDateString();
    },
    
    applyFilters() {
      this.appliedFilters = { ...this.filters };
      this.currentPage = 1;
    },
    
    clearFilters() {
      this.filters = {
        gender: '',
        nationality: '',
        ageMin: '',
        ageMax: '',
        addedby: '',
        address: '',
        dateFrom: '',
        dateTo: ''
      };
      this.appliedFilters = {};
      this.currentPage = 1;
    },
    
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    edit(id, name, gender, telephone, nationality, address, dateofbirth) {
      this.id = id;
      this.name = name;
      this.gender = gender;
      this.telephone = telephone;
      this.nationality = nationality;
      this.address = address;
      this.dateofbirth = dateofbirth;
      this.$bvModal.show('edit-patient');
    },
    
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show('delete-patient');
    },
    
    async editPatient() { 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      let url = "/updatepatient";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPatients();
          this.$bvModal.hide('edit-patient');
          this.name = "";
          this.gender = "";
          this.nationality = "";
          this.telephone = "";
          this.address = "";
          this.dateofbirth = "";
        }
      });
    },
    
    async removePatient() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removepatient";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPatients();
          this.$bvModal.hide('delete-patient');
        }
      });
    },
    
    // Export to Excel
    exportToExcel() {
      const exportData = this.filteredItems.map((item, index) => ({
        '#': index + 1,
        'Name': item.name,
        'Gender': item.gender,
        'Age': this.calculateAge(item.date_of_birth),
        'Telephone': item.telephone,
        'Nationality': item.nationality,
        'Address': item.address,
        'Added By': item.addedby,
        'Added On': this.formatDate(item.addedon)
      }));
      
      const ws = XLSX.utils.json_to_sheet(exportData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Patients');
      XLSX.writeFile(wb, `patients_${new Date().toISOString().slice(0,19)}.xlsx`);
    },
    
    // Print/Save as PDF using browser's native functionality
    printPatients() {
      // Prepare the print content
      const printWindow = window.open('', '_blank');
      const currentDate = new Date().toLocaleString();
      const maleCount = this.filteredItems.filter(p => p.gender === 'Male').length;
      const femaleCount = this.filteredItems.filter(p => p.gender === 'Female').length;
      
      // Generate table rows
      let tableRows = '';
      this.filteredItems.forEach((item, index) => {
        tableRows += `
          <tr>
            <td>${index + 1}</td>
            <td>${this.escapeHtml(item.name)}</td>
            <td>${item.gender}</td>
            <td>${this.calculateAge(item.date_of_birth)}</td>
            <td>${item.telephone}</td>
            <td>${item.nationality}</td>
            <td>${this.escapeHtml(item.address || '')}</td>
            <td>${item.addedby}</td>
            <td>${this.formatDate(item.addedon)}</td>
          </tr>
        `;
      });
      
      // Write the HTML content
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>Patients List Report</title>
          <style>
            @media print {
              body {
                margin: 0;
                padding: 20px;
              }
              .no-print {
                display: none;
              }
              .print-container {
                display: block;
              }
            }
            
            body {
              font-family: Arial, Helvetica, sans-serif;
              padding: 20px;
              margin: 0;
            }
            
            .print-header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #333;
            }
            
            .print-header h1 {
              color: #2c3e50;
              margin: 0 0 10px 0;
            }
            
            .print-header p {
              color: #7f8c8d;
              margin: 5px 0;
            }
            
            .print-summary {
              margin-bottom: 20px;
              padding: 15px;
              background-color: #f5f5f5;
              border-radius: 5px;
            }
            
            .print-summary p {
              margin: 5px 0;
              font-size: 14px;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 12px;
            }
            
            th {
              background-color: #34495e;
              color: white;
              padding: 10px;
              border: 1px solid #2c3e50;
              text-align: left;
            }
            
            td {
              padding: 8px;
              border: 1px solid #ddd;
            }
            
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            
            .print-footer {
              text-align: center;
              margin-top: 30px;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              font-size: 10px;
              color: #7f8c8d;
            }
            
            .print-button {
              text-align: center;
              margin-bottom: 20px;
            }
            
            button {
              background-color: #3498db;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 5px;
              cursor: pointer;
              font-size: 14px;
            }
            
            button:hover {
              background-color: #2980b9;
            }
          </style>
        </head>
        <body>
          <div class="print-button no-print">
            <button onclick="window.print();">Click here to print or save as PDF</button>
            <button onclick="window.close();" style="background-color: #95a5a6; margin-left: 10px;">Close</button>
          </div>
          
          <div class="print-container">
            <div class="print-header">
              <h1>Patients List Report</h1>
              <p>Generated on: ${currentDate}</p>
            </div>
            
            <div class="print-summary">
              <p><strong>Summary Statistics:</strong></p>
              <p>Total Patients: ${this.filteredItems.length}</p>
              <p>Gender Distribution: Male (${maleCount}) | Female (${femaleCount})</p>
              <p>Filters Applied: ${Object.keys(this.appliedFilters).filter(k => this.appliedFilters[k]).length} active filter(s)</p>
            </div>
            
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Telephone</th>
                  <th>Nationality</th>
                  <th>Address</th>
                  <th>Added By</th>
                  <th>Added On</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
            
            <div class="print-footer">
              <p>This report was generated automatically from the Patient Management System.</p>
              <p>Printed on: ${currentDate}</p>
            </div>
          </div>
        </body>
        </html>
      `);
      
      printWindow.document.close();
      printWindow.focus();
      
      // Auto-trigger print after a short delay
      setTimeout(() => {
        // Don't auto-print, let user click the button
        // This gives them time to adjust settings if needed
      }, 100);
    },
    
    // Helper function to escape HTML characters
    escapeHtml(text) {
      if (!text) return '';
      const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      };
      return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }
  },
};
</script>

<style scoped>
.gap-2 {
  gap: 0.5rem;
}

@media print {
  .no-print {
    display: none;
  }
}
</style>